import { Outlet, useLocation } from 'react-router-dom';

function AuthLayout() {
  const { pathname } = useLocation();

  return (
    <div
      style={{ background: `url('/images/bg.webp')` }}
      className="h-[100dvh] overflow-hidden w-full !bg-no-repeat !bg-cover !bg-top grid grid-cols-[1fr_minmax(0,30rem)_1fr]"
    >
      <div className="max-md:hidden flex justify-center items-center">
        <img src="/images/logo-9winbet-v2.webp" alt="" className="w-full max-w-xs" />
        {/* <img src="/images/logo.webp" alt="" className="w-full max-w-xs" /> */}
      </div>

      <main
        key={pathname}
        className="bg-[#eef3f7] col-start-2 col-end-2 animate-fade-in relative overflow-y-scroll overflow-x-hidden scrollbar-hidden"
      >
        <Outlet />
      </main>
    </div>
  );
}

export default AuthLayout;
